import { pushTo } from '@app/core/routing';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { useSocialExportUploadCardActions } from '@app/modules/social-export/publish/useSocialExportUploadCardActions';
import { socialExport, webApi } from '@mi-front/api-clients';
import { useQueryClient } from '@tanstack/react-query';

export interface UseComposeSocialExportUploadItemCardActionsParams {
  compositionId: string;
  upload: webApi.CompositionSocialUploadItemDto;
}

/**
 * Composition upload card actions: wires shared menu/dialog logic to composition queries and routes.
 */
export function useComposeSocialExportUploadItemCardActions({
  compositionId,
  upload,
}: UseComposeSocialExportUploadItemCardActionsParams) {
  const queryClient = useQueryClient();
  const platform = socialPlatforms.get(upload.platform);

  return useSocialExportUploadCardActions({
    upload,
    onRetry: () => {
      pushTo(composeRouteGenerator.upload(compositionId, platform.id));
    },
    onDeleteSuccess: async (uploadId: string) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: webApi.getCompositionsDetailSocialUploadsQueryKey(compositionId),
        }),
        queryClient.invalidateQueries({
          queryKey: socialExport.getUploadQueryKey(uploadId),
        }),
      ]);
    },
    onPromoteSuccess: async (uploadId: string) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: webApi.getCompositionsDetailSocialUploadsQueryKey(compositionId),
        }),
        queryClient.invalidateQueries({
          queryKey: socialExport.getUploadQueryKey(uploadId),
        }),
      ]);
    },
  });
}
